import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import type { NoopT } from 'declarations/types/common';
import useTicketReopenApprovalPopup from 'pages/TicketsPage/components/TicketDetailsPopup/hooks/useTicketDetailsPopup';

import { getPopupContentStyle } from './DeleteTicketPopup.styled';
import useDeleteTicketPopup from './hooks/useDeleteTicketPopup';

type DeleteTicketPopupPropsT = {
  ticketId: string;
  isOpen: boolean;
  onClose: NoopT;
};

const DeleteTicketPopup: FC<DeleteTicketPopupPropsT> = ({ ticketId, isOpen, onClose }) => {
  const { isMobile } = useResponsive();
  const { isLoadingTicketDetails, isTicketDetailsFetchingError } = useTicketReopenApprovalPopup();
  const { isDeletingTicket, handleCloseDeletePopup, handleClosePopup } = useDeleteTicketPopup();

  return (
    <Popup
      nested
      popupId={ScrollLockIdE.TicketDetailsPopup}
      contentStyle={getPopupContentStyle(isMobile)}
      isOpen={isOpen}
      onClose={handleClosePopup(onClose)}
      showCloseBtn={isLoadingTicketDetails || !!isTicketDetailsFetchingError}
      closeOnEscape={false}
    >
      <Typography variant="h6" color="text.primary" align={isMobile ? 'center' : 'left'}>
        Are you sure you want to delete the ticket?
      </Typography>
      <Box display="flex" justifyContent={isMobile ? 'center' : 'flex-end'} sx={{ mt: 2 }} gap={1}>
        <Button variant="outlined" onClick={handleClosePopup(onClose)}>
          No
        </Button>
        <Button
          variant="contained"
          disabled={isDeletingTicket}
          onClick={handleCloseDeletePopup({ ticketId, onClose })}
        >
          {isDeletingTicket ? 'Deleting...' : 'Yes'}
        </Button>
      </Box>
    </Popup>
  );
};

export default DeleteTicketPopup;
